<template>
  <div v-show="isVisible" id="teka-chat"></div>
</template>

<script>
if (!("crypto" in window)) {
  window.crypto = {};
}

if (typeof window.crypto.randomUUID !== "function") {
  window.crypto.randomUUID = function randomUUID() {
    const template = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
    return template.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
}
const { TekaChat } = require('@zeedhi/teka-chat-js');

export default {
  name: "TekaChat",
  props: {
    isVisible: { type: Boolean, default: true },
    customClass: { type: String, default: "" }
  },
  mounted() {
    if (this.isVisible && process.env.VUE_APP_ENABLE_CHATBOT === "true") {
      TekaChat.initializeChat("#teka-chat", {
        chatEndpoint: process.env.VUE_APP_CHAT_ENDPOINT,
        chatEndpointHttp: process.env.VUE_APP_CHAT_ENDPOINT_HTTP,
        backendURL: process.env.VUE_APP_BASE_URI,
        productId: "5216",
      });
    }
  }
};
</script>

<style>
.teka-chat-container{
  inset: auto 40px 50px auto !important; 
}
/* exemplo de estilo customizado aplicável */
/*#teka-chat.custom-dark .tk-chat-ui {
  background: #1e1e1e !important;
  color: white !important;
}*/
</style>
